import { component } from "picoapp";
import { store } from "@/vue/config/store";

export default component((node, context) => {
  const quantityInput = node.querySelector('input[name="quantity"]');
  const quantityOption = node.querySelector(".js-quantity-option");
  const quantitySelectorButtons = node.querySelectorAll(
    "[data-quantity-selector]"
  );

  quantitySelectorButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.classList.contains("active-quantity")) return;
      quantitySelectorButtons.forEach((_button) => {
        _button.classList.remove("active-quantity");
        _button.setAttribute("aria-current", "false");
      });
      button.classList.add("active-quantity");
      button.setAttribute("aria-current", "true");

      const quantity = button.dataset.quantity;
      quantityInput.value = quantity;

      context.emit("product:update", (state) => {
        return { ...state, quantity };
      });

      const currentQuantity = node.querySelector(
        'input[name="quantity"]'
      ).value;
      const setSize = quantityOption.dataset.setSize;
      quantityOption.innerHTML = parseInt(currentQuantity) * parseInt(setSize);

      const variant = context.getState().currentVariant;
      if (!variant) return;

      if (parseInt(quantity) > 1) {
        const variantSetPrice = store.getters["metafields/getVariantSetPrice"](
          variant.id
        );
        const variantSetComparePrice = store.getters[
          "metafields/getVariantSetCompareAtPrice"
        ](variant.id);
        const productSetPrice = store.getters["metafields/getProductSetPrice"](
          parseInt(node.dataset.productId)
        );
        const productSetComparePrice = store.getters[
          "metafields/getProductSetCompareAtPrice"
        ](parseInt(node.dataset.productId));

        window.dispatchEvent(
          new CustomEvent("price:update", {
            detail: {
              price: variantSetPrice || productSetPrice,
              comparePrice: variantSetComparePrice || productSetComparePrice,
            },
          })
        );
      } else {
        window.dispatchEvent(
          new CustomEvent("price:update", {
            detail: {
              price: variant.price,
              comparePrice: variant.compare_at_price,
            },
          })
        );
      }
    });
  });
});
